// import moment from "moment";
import React from "react";
import BrandLogo from "../components/BrandLogo";
import InvitationMessage from "../components/invitation/InvitationMessage";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { DownloadInvoiceButton } from "./DownloadInvoiceButton";

interface Props {
  brand: server.dto.BrandSmall
  invitationBody: string
  message: string

  completedUtc: Date

  docUrl: string
}

const FinishedBrandInfoPanel = (props: Props) => {
  return <SectionPanel.Panel>
    <div className="content-section flex-column gap-big">
      <BrandLogo brand={props.brand} boxWhenNoImage />

      <div>
        <InvitationMessage
          message={props.message}
          brandName={props.brand.name}
        />
      </div>

      <DownloadInvoiceButton downloadFileUrl={props.docUrl} />
    </div>

  </SectionPanel.Panel>;
};

export default FinishedBrandInfoPanel;